import React, { useContext } from "react";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import { clearAuthState } from "../reuseableComponents/auth/logoutUtils";

const RequestAccessSuccess = () => {
    const { setUser } = useContext(UserContext);

    const logout = () => {
        clearAuthState({ includeCookie: true });

        setUser?.({ isPublic: true });
        window.location.assign("/");
      };

    return (
        <div style={{width: "100%", color: "black", textAlign: "center", marginTop: "50px"}}>
            <p>Thank you for your request.<br/>
            You will receive an email after your request has been accepted. <br/>
            <button type="button" onClick={logout} style={{textDecoration: "underline", cursor: "pointer", background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", display: "inline"}}>Logout</button> now to continue to use WaterLink as a public user.</p>
        </div>
    );
}

export default RequestAccessSuccess;